import { MoviePlusOutlineIcon } from './MoviePlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 1171D3A1-94AD-4DF5-81E0-D7800C05A0AC
 * name movie-plus-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-plus-outline.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardPlusOutlineIcon = MoviePlusOutlineIcon;
export default ClapperboardPlusOutlineIcon